// Classe de configuration de l'application

/* CONFIGURATION GLOBALE, QUELQUE SOIT L'ENVIRONNEMENT */

// prefixe du back
export const PREFIX_BACK = process.env.REACT_APP_CITRA_URL + '/v1/';

export const PREFIX_TUNNEL_DIRIGEANT = '/tunneldirigeant';

// fréquence de rafraichissement du token JWT en millisecondes : 10 minutes
export const FREQUENCE_RAFRAICHISSEMENT_TOKEN = 60000;

export const WAIT_REFRAICHISSEMENT_TOKEN_EN_COURS = 1000;

// Nom des routes de l'application
export const ROUTE_HOME = '/';
export const ROUTE_CONNEXION = '/connexion';
export const ROUTE_ACCUEIL_GALAXY = '/accueil';
export const ROUTE_DOSSIERS_GALAXY = '/souscrire/suivi-dossiers';
export const ROUTE_ACCES_CONTRIBUTEUR = '/connexion/accesContributeur';
export const ROUTE_CONTINUER_SUR_ORDINATEUR = '/continuerSurOrdinateur';
export const ROUTE_FORMULE_PARTICIPATION = PREFIX_TUNNEL_DIRIGEANT + '/formuleParticipation';
export const ROUTE_VERSION_VIEWER = '/version'

export const DIRIGEANT = 'DIRIGEANT';
export const FLAG_REDIRECT = '?c';

export const CONTACT_EMAIL = 'epargne.salariale@generali.com';

export const SEUIL_MOBILE = 480;

export const RESEAU_LFAC = 'LFAC';

export const STATUT_LIASSE = {
  ANNULEE: 'ANNULEE',
  SIGNEE: 'SIGNEE',
  ENVOYEE: 'ENVOYEE'
};

export const TYPE_DOCUMENT = {
  RIB: 'RIB',
  ANNEXE_KYC_PERSON: 'JUSTIFICATIFS_KYC_PERS_PHYSIQUE',
  ANNEXE_KYC_ENTITY: 'JUSTIFICATIFS_KYC_PERS_MORALE',
  ACCORD_INTERESSEMENT: 'ACCORD_INTERESSEMENT',
  ACCORD_PARTICIPATION: 'ACCORD_PARTICIPATION',
  ACCORD_PPV: 'ACCORD_PPV',
  STATUTS_ENTREPRISE: 'STATUTS_ENTREPRISE',
  LISTE_BENEFICIAIRES: 'LISTE_BENEFICIAIRES',
  JUSTIFICATIF_IDENTITE: 'JUSTIFICATIF_IDENTITE',
  CONSULTATION_ENTREPRISE: 'CONSULTATION_ENTREPRISE',
  JUSTIFICATIF_IDENTITE_ENTREPRISE: 'JUSTIFICATIF_IDENTITE_ENTREPRISE',

  //Associations déclarées & publiques
  RECEP_DECLA_PREF: 'RECEP_DECLA_PREF',
  RECEP_INSERTION: 'RECEP_INSERTION',

  //Associations publiques
  DECRET_RECO: 'DECRET_RECO',

  //Profession libérale
  CARTE_PROFESSIONELLE: 'CARTE_PROFESSIONNELLE',
};
